import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IPromoModalProps } from '@cian/frontend-newbuilding-promo-modal-widget';

import { UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY } from '../../../constants/config';
import { selectPage } from '../../../selectors/analytics';
import { IPromoDetails } from '../../../types/promos/promoDetails';
import { useApplicationContext } from '../../../utils/applicationContext';
import { getNewbuildingPromosAnchor } from '../../../utils/url';

type TAvaliableNewbuildingsList = IPromoModalProps['promo']['availableJks'];

const EMPTY_RESULT: TAvaliableNewbuildingsList = [];

export const useNewbuildingLinks = (promoDetails: IPromoDetails | null): TAvaliableNewbuildingsList => {
  const { config } = useApplicationContext();
  const { siteType } = useSelector(selectPage);

  const uniquePromoIdParam = config.get<string>(UNIQUE_PROMO_ID_QUERY_PARAM_CONFIG_KEY) ?? 'uniquePromoId';

  return useMemo(() => {
    if (!promoDetails) {
      return EMPTY_RESULT;
    }

    const jks: TAvaliableNewbuildingsList = promoDetails.newbuildingLinks.map((link, index) => ({
      id: promoDetails.newbuildingIds[index] || index,
      name: link.name,
      link: `${link.url}?${uniquePromoIdParam}=${promoDetails.uniquePromoId}${getNewbuildingPromosAnchor(siteType)}`,
    }));

    if (jks.length < promoDetails.newbuildingIds.length) {
      promoDetails.newbuildingIds.slice(jks.length).forEach(id => {
        jks.push({
          id,
        });
      });
    }

    return jks;
  }, [promoDetails, siteType, uniquePromoIdParam]);
};
